document.addEventListener('DOMContentLoaded', function() {
    const pageStepMap = {
        'gform_page_4_1': 'step-1',
        'gform_page_4_2': 'step-2',
        'gform_page_4_3': 'step-3',
        'gform_page_4_4': 'step-4',
        'gform_page_4_5': 'step-5'
    };
    
    function updateSteps() {
        document.querySelectorAll('._step').forEach(step => step.classList.remove('active'));
        
        Object.entries(pageStepMap).forEach(([pageId, stepId]) => {
            const page = document.getElementById(pageId);
            const step = document.getElementById(stepId);
            if (page && step) {
                const computedStyle = window.getComputedStyle(page);
                const isVisible = computedStyle.display !== 'none';
                if (isVisible) {
                    step.classList.add('active');
                }
            }
        });
    }
    
    const observer = new MutationObserver(updateSteps);
    
    Object.keys(pageStepMap).forEach(pageId => {
        const page = document.getElementById(pageId);
        if (page) {
            observer.observe(page, { 
                attributes: true, 
                attributeOldValue: true,
                subtree: false
            });
        }
    });
    
    setInterval(updateSteps, 100);
    
    updateSteps();
});